<script setup lang="ts">
import type { EquipmentHealthState } from "@/types/equipement";
import { cn } from "@/shadcn/lib/utils";

interface Props {
  state: EquipmentHealthState | null,
}
const props = defineProps<Props>();

const stateClasses: Record<string, string> = {
  perfect: 'tw:bg-emerald-600/10 tw:text-emerald-600',
  good: 'tw:bg-green-600/10 tw:text-green-600',
  average: 'tw:bg-amber-600/10 tw:text-amber-600',
  watch: 'tw:bg-orange-600/10 tw:text-orange-600',
  maintenance_required: 'tw:bg-rose-600/10 tw:text-rose-600',
  unusable: 'tw:bg-gray-600/10 tw:text-gray-600',
  awaiting_parts: 'tw:bg-blue-600/10 tw:text-blue-600',
};

</script>

<template>
  <div class="tw:flex">
    <div :class="cn('tw:flex-none tw:rounded-full tw:p-1', props.state ? stateClasses[props.state.value] : 'tw:bg-gray-400/10 tw:text-gray-400')">
      <div class="tw:size-1.5 tw:rounded-full tw:bg-current"></div>
    </div>
  </div>
</template>

<style scoped>

</style>